import styled from "styled-components";
import NavsLogo from "../../assets/nav.svg";
import {Link, useNavigate} from "react-router-dom";

const Container = styled.div`
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 30px 0;
    
    background: #1f1f20;

    div:first-of-type {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 15px;
        cursor: pointer;

        img {
            width: 64px;
            height: 64px;
        }

        h1 {
            font-family: 'Inter', sans-serif;
            color: white;
            font-size: 50px;
            margin: 0;
            padding: 0;
        }
    }

    div:last-of-type {
        display: flex;
        flex-direction: row;
        gap: 20px;
        margin-top: 25px;

        a {
            cursor: pointer;
            font-family: 'Inter', sans-serif;
            font-weight: 300;
            text-decoration: none;
            color: #ddd;

            padding: 3px 5px;
            border-bottom: solid 1px #9e7f2d;
        }
    }

    @media screen and (min-width: 800px) {
        flex-direction: row;
        justify-content: space-between;
        padding: 30px 70px;
        margin-bottom: 100px;

        div:first-of-type {
            gap: 20px;
        }

        div:last-of-type {
            gap: 30px;
            font-size: 20px;
            margin-top: 0;
        }
    }
`;

export default function Header() {
    const navigate = useNavigate();

    return (
        <Container>
            <div onClick={() => navigate('/')}>
                <img alt="Navs Logo" className="navlogo" src={NavsLogo}/>
                <h1>SNIPES</h1>
            </div>
            <div>
                <Link to="/rules">Rules</Link>
                <Link to="/gmindex">GroupMe Index</Link>
            </div>
        </Container>
    );
}